import axios from 'axios'
import authentificationService from '@/services/authentificationService'

class FacetsService {

  getHttpClient () {
    return new Promise((resolve, reject) => {
      if (this.httpClient) {
        resolve(this.httpClient)
      } else {
        authentificationService
          .getConnectedUser()
          .then(connectedUser => {
            this.httpClient = axios.create({
              baseURL: process.env.VUE_APP_API_URL_FACETS,
              headers: {
                'Authorization': `Basic ${connectedUser.service_token}`
              }
            })
            resolve(this.httpClient)
          })
      }
    })
  }

  findAllEquipmentTypes () {
    return this.getHttpClient()
      .then(httpClient =>
        httpClient
          .get('/equipment')
          .then(response => {
            response.data.sort((d1, d2) => d2.count - d1.count)
            return response.data
          })
      )
  }

  findAllPackagingTypes () {
    return this.getHttpClient()
      .then(httpClient =>
        httpClient
          .get('/packaging')
          .then(response => {
            response.data.sort((d1, d2) => d2.count - d1.count)
            return response.data
          })
      )
  }

  findAllPickupRegions () {
    return this.getHttpClient()
      .then(httpClient =>
        httpClient
          .get('/pickup')
          .then(response => {
            response.data.sort((d1, d2) => d1.label.localeCompare(d2.label))
            return response.data
          })
      )
  }

  findAllDeliveryRegions () {
    return this.getHttpClient()
      .then(httpClient =>
        httpClient
          .get('/delivery')
          .then(response => {
            response.data.sort((d1, d2) => d1.label.localeCompare(d2.label))
            return response.data
          })
      )
  }

}

export default new FacetsService()
